/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useCallback} from 'react';
// redux
import { useSelector, useDispatch } from 'react-redux';
// components
import Header from "../../../material/structure/header/header";
import { updateSelectedSite } from "../../../state/thunks/session";
// styles
import injectSheet from 'react-jss';
import styles from "./settings_styles";

const SettingsHeader = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const {
    account: {
      sites = {}
    },
    session: {
      siteUUID,
    },
  } = useSelector((state) => state);

  const handleSelectSite = useCallback((e) =>
    dispatch(updateSelectedSite(e.target.value))
    , [dispatch]);

  return (
    <Header>
      <div
        className="field type-select isActive-false disabled-undefined isValid-undefined hasValue-false Field-field Field-field">
        <div className={props.classes.SelectWrapper}>
          <i className="fas fa-caret-down "></i>
          <select
            onChange={handleSelectSite}
            className={props.classes.SelectField}
            value={siteUUID || ''}
            type="text"
            disabled>
            {Object.keys(sites).map(key =>
              <option key={key} value={key}>{sites[key]}</option>)}
          </select>
        </div>
      </div>
    </Header>
  )
});

export default SettingsHeader;
